/* "Will my apps work?" search (snippets/app-compat.liquid). The list ({endpoint minus /request}/list, falling back to
   assets/app-compat.json) is fetched the first time the
   input is focused or the block scrolls into view. Request button: POST {app, locale, known} to the block's endpoint;
   untested and unlisted apps also GET {endpoint minus /request}/count?app= -> {count, status}. A status set in the
   Lagom Requests admin app (testing / works / works_with_issues / doesnt_work / blocked) overrides "untested" for that app. Requested apps are
   remembered in localStorage. */
(function () {
  var KEY = 'lagom_compat_requested', MAX = 6;
  var LIVE = { testing: 'testing', works: 'works', works_with_issues: 'partial', doesnt_work: 'not_working', blocked: 'blocked' };   /* admin status -> pill */
  /* Results order: status first (works on top), then name/alias starts with the query, then contains it. */
  var RANK = { works: 0, partial: 1, untested: 2, not_working: 3, blocked: 4 };
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ø/g, 'o').replace(/æ/g, 'ae').replace(/ß/g, 'ss').replace(/ł/g, 'l').replace(/đ/g, 'd').trim();
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readReq() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function saveReq(app) { try { var a = readReq(); if (a.indexOf(norm(app)) < 0) { a.push(norm(app)); localStorage.setItem(KEY, JSON.stringify(a.slice(-100))); } } catch (e) { /* ignore */ } }
  function isReq(app) { return readReq().indexOf(norm(app)) > -1; }

  function init(root) {
    if (root.dataset.ready) { return; }
    root.dataset.ready = '1';
    var T = {}; try { T = JSON.parse(root.querySelector('[data-compat-t]').textContent); } catch (e) { return; }
    var dec = document.createElement('textarea');
    Object.keys(T).forEach(function (k) { dec.innerHTML = T[k]; T[k] = dec.value; });   /* | t returns HTML-escaped text */
    var input = root.querySelector('input'), live = root.querySelector('.compat__live');
    var sv = /^sv/i.test(root.dataset.locale || '');
    var ep = (root.dataset.endpoint || '').trim();
    if (!/^https?:\/\//.test(ep)) { ep = ''; }
    var countBase = ep.replace(/\/request\/?$/, '');
    var iconBase = root.dataset.icons || '';
    var apps = null, loading = null, timer = 0, counts = {}, liveStatus = {}, liveIcon = {};

    function load() {
      if (loading) { return loading; }
      /* The list lives in the Lagom Requests app (edited in its admin); the theme copy is the fallback. */
      var fromTheme = function () { return fetch(root.dataset.src).then(function (r) { return r.json(); }); };
      var list = countBase ? fetch(countBase + '/list').then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); })
        .then(function (d) { if (!Array.isArray(d) || !d.length) { throw new Error('empty'); } return d; }).catch(fromTheme) : fromTheme();
      loading = list.then(function (d) {
        apps = (Array.isArray(d) ? d : []).map(function (a) {
          var keys = [a.name].concat(String(a.aliases || '').split(',')).map(norm).filter(Boolean);
          return { a: a, keys: keys };
        });
        if (input.value) { run(); }
      }).catch(function () { apps = []; });
      return loading;
    }

    function search(q) {
      var hits = [];
      apps.forEach(function (x, i) {
        var m = x.keys.some(function (k) { return k.indexOf(q) === 0; }) ? 0 : x.keys.some(function (k) { return k.indexOf(q) > -1; }) ? 1 : -1;
        if (m > -1) { hits.push({ a: x.a, s: (x.a.status in RANK ? RANK[x.a.status] : 2), m: m, i: i }); }
      });
      hits.sort(function (a, b) { return a.s - b.s || a.m - b.m || a.i - b.i; });
      return hits.slice(0, MAX).map(function (h) { return h.a; });
    }
    function known(q) { return apps && apps.some(function (x) { return x.keys.indexOf(norm(q)) > -1; }); }

    function reqButton(app, isKnown) {
      if (!ep) { return ''; }
      var done = isReq(app);
      return '<button class="compat__req" type="button" data-app="' + esc(app) + '" data-known="' + (isKnown ? 'yes' : 'no') + '"' + (done ? ' disabled' : '') + '>' + esc(done ? T.requested : T.request) + '</button>';
    }
    function countLine(app) {
      var n = counts[norm(app)];
      return '<p class="compat__count" data-count-for="' + esc(norm(app)) + '"' + (n >= 3 ? '' : ' hidden') + '>' + (n >= 3 ? esc(T.count.replace('{count}', n)) : '') + '</p>';
    }
    function item(a) {
      var st = T[a.status] ? a.status : 'untested';
      if (st === 'untested' && liveStatus[norm(a.name)]) { st = liveStatus[norm(a.name)]; }
      var note = sv ? (a.note_sv || a.note_en) : a.note_en;
      var sub = '';
      if (st === 'blocked') { sub = '<p class="compat__note">' + esc(T.blocked_note) + '</p>'; }
      else if (st !== 'untested' && note) { sub = '<p class="compat__note">' + esc(note) + '</p>'; }
      if (st === 'untested') { sub = countLine(a.name); }
      var icon = a.icon ? (/^(https?:)?\/\//.test(a.icon) ? a.icon : iconBase + a.icon) : (liveIcon[norm(a.name)] || '');
      var mono = '<span class="compat__icon-tile compat__mono" aria-hidden="true"' + (icon ? ' hidden' : '') + '>' + esc((a.name.match(/[0-9A-Za-zÀ-ÿ]/) || ['?'])[0].toUpperCase()) + '</span>';
      return '<li class="compat__item">' +
        (icon ? '<img class="compat__icon-tile" src="' + esc(icon) + '" width="40" height="40" alt="" loading="lazy" decoding="async">' : '') + mono +
        '<div><span class="compat__name">' + esc(a.name) + '</span>' +
        (a.category ? '<span class="compat__cat">' + esc(a.category) + '</span>' : '') + sub + '</div>' +
        '<div class="compat__side"><span class="compat__pill compat__pill--' + st + '">' + esc(T[st]) + '</span>' +
        (st === 'untested' ? reqButton(a.name, true) : '') + '</div></li>';
    }

    function paint(html) {
      live.innerHTML = html;
      live.classList.add('is-fading'); void live.offsetWidth; live.classList.remove('is-fading');
    }
    function fetchCount(app) {
      var k = norm(app);
      if (!countBase || k in counts) { return; }
      counts[k] = 0;
      fetch(countBase + '/count?app=' + encodeURIComponent(app)).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (d && typeof d.count === 'number') { setCount(app, d.count); }
        if (d) { if (d.icon) { liveIcon[norm(app)] = d.icon; } setLive(app, d.status); }
      }).catch(function () { /* silent */ });
    }
    function setLive(app, status) {
      var st = LIVE[status];
      if (!st || !T[st] || liveStatus[norm(app)] === st) { return; }
      liveStatus[norm(app)] = st;
      run();
    }
    function setCount(app, n) {
      var k = norm(app);
      counts[k] = n;
      if (n < 3) { return; }
      Array.prototype.forEach.call(live.querySelectorAll('[data-count-for]'), function (p) {
        if (p.getAttribute('data-count-for') === k) { p.textContent = T.count.replace('{count}', n); p.hidden = false; }
      });
    }

    function run() {
      var raw = input.value.trim(), q = norm(raw);
      if (!q) { paint(''); return; }
      if (!apps) { load(); return; }
      var res = search(q);
      if (!res.length) {
        if (liveStatus[q]) { paint('<ul class="compat__list">' + item({ name: raw, status: 'untested' }) + '</ul>'); return; }
        fetchCount(raw);
        paint('<div class="compat__empty"><span>' + esc(T.no_match).replace('{query}', esc(raw)) + '</span>' + reqButton(raw, known(raw)) + '</div>' +
          '<div>' + countLine(raw) + '</div>');
        return;
      }
      paint('<ul class="compat__list">' + res.map(item).join('') + '</ul>');
      res.forEach(function (a) { if (a.status === 'untested') { fetchCount(a.name); } });
    }

    live.addEventListener('error', function (e) {
      var img = e.target;
      if (img.tagName === 'IMG' && img.nextElementSibling) { img.nextElementSibling.hidden = false; img.remove(); }
    }, true);
    input.addEventListener('focus', load);
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); run(); } });

    live.addEventListener('click', function (e) {
      var b = e.target.closest('.compat__req');
      if (!b || b.disabled || !ep) { return; }
      var app = b.getAttribute('data-app'), label = b.textContent;
      b.disabled = true;
      fetch(ep, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ app: app, locale: root.dataset.locale || '', known: b.getAttribute('data-known') })
      }).then(function (r) {
        if (!r.ok) { throw new Error(r.status); }
        return r.json().catch(function () { return {}; });
      }).then(function (d) {
        saveReq(app);
        b.textContent = T.requested;
        if (d && typeof d.count === 'number') { counts[norm(app)] = -1; setCount(app, d.count); }
        if (d) { if (d.icon) { liveIcon[norm(app)] = d.icon; } setLive(app, d.status); }
      }).catch(function () { b.disabled = false; b.textContent = label; });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '200px' });
      io.observe(root);
    }
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-compat]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  document.addEventListener('shopify:section:load', start);

  /* "App check" links (…#app-check): on the page that has the block, scroll there instead of reloading (the header menu
     in core.js already closes itself and scrolls; any other link is scrolled here), then focus the search input. */
  function motionOff() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function focusSearch(target, wait) {
    var input = target.querySelector('.compat__input');
    if (input) { setTimeout(function () { input.focus({ preventScroll: true }); }, wait); }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="#app-check"]') : null, target = document.getElementById('app-check');
    if (!a || !target || e.metaKey || e.ctrlKey || e.shiftKey) { return; }
    var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) { return; }
    if (!e.defaultPrevented) {
      e.preventDefault();
      target.scrollIntoView({ behavior: motionOff() ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', '#app-check'); }
    }
    focusSearch(target, motionOff() ? 60 : 750);
  });
  /* Arriving from another page with #app-check: land on it again once the page has loaded (images above can shift it). */
  if (location.hash === '#app-check') {
    window.addEventListener('load', function () { var t = document.getElementById('app-check'); if (t) { t.scrollIntoView({ block: 'start' }); } });
  }
})();
